import { useTranslation } from 'next-i18next';

import Empty from '../Icons/svg/Empty';

import styles from './NoData.module.scss';

function NoData() {
  const { t } = useTranslation('common');
  return (
    <div className={styles.container}>
      <figure>
        <Empty />
      </figure>
      <p>{t('noData')}</p>
    </div>
  );
}

export default NoData;
